// The steps of Meet Jolt, the first-run welcome a player gets on joulelingo.com instead of the
// generic one (OnboardingDialog decides). Plain data so it runs under `node --test`.
import { CHARACTER_NAME } from '../../../components/game/moods.js'

/**
 * Jolt's steps for this player, in order: `{ key, mood, title, body }`. The challenge step is
 * there only when the org runs the weekly challenge, so Jolt never promises what isn't on.
 */
export function meetJoltSteps({ quizOn = false } = {}) {
    const steps = [
        {
            key: 'hello',
            mood: 'waving',
            title: `Hi, I’m ${CHARACTER_NAME}!`,
            body: 'I help everyone here use less energy. Let me show you around.'
        },
        {
            key: 'goal',
            mood: 'happy',
            title: 'We save energy as a team',
            body: 'Each week we all share one goal: use a little less energy than usual. Switching off what nobody is using helps.'
        }
    ]
    if (quizOn) {
        steps.push({
            key: 'challenge',
            mood: 'thinking',
            title: 'Play the weekly challenge',
            body: 'There’s a new quiz about our energy every week. Finish it each week to grow your streak.'
        })
    }
    steps.push({
        key: 'ready',
        mood: 'celebrating',
        title: 'Ready?',
        body: 'Your home page shows how we’re doing. I’ll be there too.'
    })
    return steps
}
